export default __webpack_public_path__ + "static/media/Hive Arts-03 2.9e03bf05.png";